import { Component } from '@angular/core';
@Component({ 
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'faktoring-web';
}

//todo:tokenlı url dinlenecek. Servis objesi ile kaydedilecek
